import React from 'react';
import { Form, Badge } from 'react-bootstrap';
import DataTable from '../common/DataTable';
import { formatCurrency } from '../../utils/formatters';

const ReconcileTable = ({ transactions, selectedTxIds, onToggle, selectedAccount }) => {
  const headers = [
    { label: '', width: '40px' },
    { label: 'Date', key: 'date', sortable: true },
    { label: 'Description', key: 'description' },
    { label: 'Category', key: 'category' },
    { label: 'Amount', key: 'amount', align: 'right' }
  ];

  return (
    <DataTable 
      headers={headers}
      data={transactions}
      emptyMessage="No transactions found for this period. Try importing them first."
      renderRow={(tx) => {
        // Calculate display amount based on which side the bank account is on
        const isOutflow = tx.fromAccount && (tx.fromAccount._id === selectedAccount || tx.fromAccount === selectedAccount);
        const displayAmount = isOutflow ? -Math.abs(tx.amount) : Math.abs(tx.amount);
        
        const txDate = new Date(tx.date);
        const displayDate = isNaN(txDate.getTime()) ? 'Invalid Date' : txDate.toLocaleDateString();

        return (
          <tr 
            key={tx._id} 
            onClick={() => onToggle(tx._id)} 
            style={{ cursor: 'pointer' }}
            className={selectedTxIds.has(tx._id) ? 'table-primary' : ''}
          >
            <td>
              <Form.Check 
                type="checkbox" 
                checked={selectedTxIds.has(tx._id)} 
                readOnly 
              />
            </td>
            <td className="small">{displayDate}</td>
            <td className="small text-truncate" style={{ maxWidth: '400px' }}>{tx.description}</td>
            <td className="small">
              {tx.category === 'Uncategorized' ? (
                <Badge variant="warning" className="text-dark">
                  <i className="fas fa-exclamation-circle mr-1"></i> Uncategorized
                </Badge>
              ) : (
                <Badge variant="light" className="border">{tx.category}</Badge>
              )}
            </td>
            <td className={`text-right font-weight-bold ${displayAmount >= 0 ? 'text-success' : 'text-danger'}`}>
              {formatCurrency(displayAmount)}
            </td>
          </tr>
        );
      }}
    />
  );
};

export default ReconcileTable;
